// extracted by mini-css-extract-plugin
module.exports = {"nieuwsModalContent":"nieuws-modal_nieuwsModalContent__ZzlnI"};